import React from "react";
import ReactDOM from "react-dom";
import Root from "./client/Root";
import * as serviceWorker from "./serviceWorker";
import "styles/css/common.css";
import "styles/css/layout.css";
import "styles/css/font.css";
import "styles/css/index.css";

import { install } from "resize-observer";

install();

console.log(
  `Updated (from ${process.env.REACT_APP_BUILD_HOST}) : ${process.env.REACT_APP_BUILD_DATE}`
);
ReactDOM.render(<Root />, document.getElementById("root"));
serviceWorker.unregister();
